import { styled, InputBase, inputBaseClasses } from '@mui/material';

export const DurationFieldContainer = styled('div')({
  display: 'inline-flex',
  flexDirection: 'column',
  gap: 6,
});

export const DurationFieldLabel = styled('span')({
  fontSize: 10,
  fontWeight: 600,
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  color: '#7B7A99',
});

export const DurationFieldControl = styled('div')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 8,
});

export const DurationFieldFielSet = styled('div')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 2,
  background: '#F7F6FD',
  border: '0.5px solid #E0DCF5',
  borderRadius: 8,
  padding: '4px 8px',
  transition: 'border-color 0.15s',
});

export const DurationFieldInputContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 2,
});

export const DurationFieldInputLabel = styled('span')({
  fontSize: 9,
  fontWeight: 600,
  letterSpacing: '0.05em',
  textTransform: 'uppercase',
  color: '#B0AECF',
});

export const DurationFieldInputBase = styled(InputBase)({
  [`& .${inputBaseClasses.input}`]: {
    border: 'none',
    outline: 'none',
    background: 'transparent',
    color: '#1A1A2E',
    fontSize: 14,
    fontWeight: 600,
    textAlign: 'center',
    minWidth: 50,
    width: 50,
    height: 26,
    padding: 0,
    fontFamily: 'inherit',
    MozAppearance: 'textfield',
  },
});

export const DurationFieldInputColon = styled('span')({
  fontSize: 13,
  fontWeight: 300,
  color: '#C0BBDF',
  padding: '0 2px',
  marginBottom: 11,
});
